// Canonical tenor bucketing shared by analyticsStore.js and every FlowSight
// chart. Previously duplicated near-verbatim inside Conversions.vue
// (tenorLabelsCanon/tenorIndexFromDays/tenorLabelFromIndex) and inside
// analyticsStore.js's own copies - single source now, both import this.
import { volumeLabelFromNotional } from './flowSightBuckets'

export const TENOR_LABELS = ['1-30D', '31-60D', '61-90D', '91-120D', '121-150D', '151-179D', '180D-209D', '>=210D']

export function tenorLabelsCanon () {
  return TENOR_LABELS
}

export function tenorIndexFromDays (days) {
  if (days >= 210) return 7
  if (days >= 180) return 6
  if (days >= 151) return 5
  if (days >= 121) return 4
  if (days >= 91) return 3
  if (days >= 61) return 2
  if (days >= 31) return 1
  return 0
}

export function tenorLabelFromIndex (i) {
  return TENOR_LABELS[i] || ''
}

// Kept here because analyticsStore's normalized row carries `volBucket`, but
// the ladder itself lives in flowSightBuckets.js - one definition, so a row's
// bucket label can never disagree with the axis that displays it.
export function bucketizeVol (notional) {
  return volumeLabelFromNotional(notional)
}
